import "@/components/MountainRidge/MountainRidge.scss";

interface MountainRidgeProps {
  className?: string;
}

/** Decorative layered alpine silhouette, drawn in SVG (no image to load). */
function MountainRidge({ className }: MountainRidgeProps) {
  return (
    <svg
      className={`mountain-ridge${className ? ` ${className}` : ""}`}
      viewBox="0 0 1440 320"
      preserveAspectRatio="xMidYMax slice"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className="mountain-ridge__far"
        d="M0 230 L120 170 L200 200 L330 110 L420 170 L520 120 L610 180 L720 90 L820 160 L930 120 L1040 180 L1160 100 L1260 160 L1360 130 L1440 170 L1440 320 L0 320 Z"
      />
      <path
        className="mountain-ridge__mid"
        d="M0 270 L140 190 L240 240 L380 140 L470 200 L560 160 L700 250 L840 150 L960 220 L1080 170 L1200 240 L1320 180 L1440 230 L1440 320 L0 320 Z"
      />
      <path
        className="mountain-ridge__near"
        d="M0 300 L180 250 L320 285 L470 235 L640 290 L800 245 L980 295 L1150 250 L1300 285 L1440 260 L1440 320 L0 320 Z"
      />
    </svg>
  );
}

export default MountainRidge;
export type { MountainRidgeProps };
